import React, { useState, useEffect } from 'react'
import { ReactComponent as AddIcon } from "assets/images/icons/project-icons/add-paygroup.svg";
import BulkActionHandler from 'components/__new/common/BulkActionHandler';
import Table from '../common/Table';
import DialogBox from 'utils/dialogBox';
import iconSearch from "assets/images/icons/icon-search.svg";
import Spinner from 'components/__new/common/Spinner';
import { ReactComponent as Check } from "assets/images/icons/check.svg";
import FormDrawer from '../common/form-drawer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getPayGroups } from 'store/entities/payroll/payrollSetup/action';
import usePayrollEssentials from 'hooks/usePayrollEssentials';
import Maybe from '../common/Maybe';
import { TableContent } from '../common/TableContent';
import { ButtonLoader } from '../common/form';
import processParams from 'utils/processParams';
import useUrlQueryParams from 'hooks/useUrlQueryParams';
import { useLocation } from 'react-router-dom';
import Pagination from '../common/pagination';

const PaygroupsListTable = ({payGroupsLoading, onMount, payGroupsData, selected, setSelected, assignPayGroupFn, unassignPayGroupFn, isViewing, title, updateLoading }) => {
    const [search, setSearch] = useState("");
    const { useSelector, dispatch } = usePayrollEssentials();
	const [paygroupModalOpen, setPaygroupModalOpen] = useState(false);
    const [batch, setBatch] = useState([]);
    const {urlQueryParams} = useUrlQueryParams();
    const location = useLocation();
    const [listParams, setListParams] = useState({ "page": 1, "limit": 10 });
    const { getPayGroupData: allPayGroups, getPayGroupLoading } = useSelector(state => state.entities.payrollSetup)

	const allUniqueIDs = payGroupsData?.data?.map((item) => item.id);
    const unassignedPayGroups = allPayGroups?.data?.filter((item) => !allUniqueIDs?.includes(item.id))?.map((item) => item.id);
	const toggleModal = () => setPaygroupModalOpen(!paygroupModalOpen)

    const toggleSingleItem = (id) => {
        const alreadyExists = batch?.indexOf(id) > -1
        if (alreadyExists) {
            const filtered = batch?.filter(item => item !== id)
            setBatch(filtered)
        } else {
            setBatch([...batch, id])
        }
    }

    const toggleSelection = (id) => {
        if(selected?.includes(id)) {
            const newItems = selected?.filter((item) => item !== id)
            setSelected(newItems)
        } else {
            setSelected([...selected, id])
        }
    }

    const fetchPaygroups = () => {
        let params = {...listParams};

        params = processParams(urlQueryParams, params, "page", "number", 1, "page");
        params = processParams(urlQueryParams, params, "limit", "number", 10, "limit");

        setListParams(params);
        onMount(params);
    }

    const clearAndClose = () => {
        setSearch("")
        setSelected([])
        toggleModal()
    }

    const toggleEntireList = () => {
        if (batch?.length !== allUniqueIDs?.length) {
            setBatch(allUniqueIDs)
        } else {
            setBatch([])
        }
    }

    const filteredItems = allPayGroups?.data?.filter(item => {
        if(search === "") {
            return true
        } else {
            return item?.name?.toLowerCase()?.includes(search?.toLowerCase())
        }
    })

    const handleSingleDelete = async (id) => {
        const actual = payGroupsData?.data?.find((item) => item.id === id)
        const result = await DialogBox({
			title: "Remove Pay Group 😰",
            content: <div className="delete-modal-text">Are you sure you want to remove <span className="delete-modal-highlight capitalize">{actual?.name?.toLowerCase()}</span>? This action cannot be undone.</div>,
			buttonYes: "Delete",
            buttonYesClass: "btn-ep-red",
			buttonNo: "Cancel",
		});
		if (result) {
            unassignPayGroupFn([id]).then(() => {
                setTimeout(() => {
                    setBatch([]);
					setSelected([]);
                    onMount(listParams);
                }, 1500);
            })
        }
    }

    const handleBulkDelete = async () => {
        const result = await DialogBox({
			title: "Remove Pay Group 😰",
            content: <div className="delete-modal-text">Are you sure you want to remove <span className="delete-modal-highlight">{batch?.length} pay groups </span>from {title}? This action cannot be undone.</div>,
			buttonYes: "Delete",
            buttonYesClass: "btn-ep-red",
			buttonNo: "Cancel",
		});
		if (result) {
            unassignPayGroupFn(batch).then(() => {
                setTimeout(() => {
                    setBatch([]);
					setSelected([]);
                    onMount(listParams);
                }, 1500);
            })
            }
    }

useEffect(() => {
    fetchPaygroups();
    // eslint-disable-next-line
}, [location])

useEffect(() => {
    setSelected([]);
    dispatch(getPayGroups());
    // eslint-disable-next-line
}, [])

	return (
		<div className='w-full'>

            <Maybe condition={paygroupModalOpen}>
                <FormDrawer display="center" size="lg" isOpen={paygroupModalOpen} setIsOpen={toggleModal}>
                    {getPayGroupLoading ? <Spinner message={updateLoading ? "Updating Pay Groups" : "Fetching Pay Groups"} /> :
                    <div className="p-7 w-full">
                            <div className="mb-5 border-b pb-3">
                                <p className="mb-1 font-semibold">Add Pay Group</p>
                            </div>

                            {payGroupsLoading === false && allPayGroups?.data?.length < 1 ?
                                <div className="table-info">
                                    <FontAwesomeIcon icon="list" />
                                    <div className="font-semibold uppercase">
                                        No Pay Groups found
                                    </div>
                                </div> :
                                <>
                                <div className="my-7">
                                    <div className="pb-6 border-b">
                                        <div className="form-group-icon h-10 rounded-md border">
                                            <label htmlFor="search">
                                                <img src={iconSearch} alt="Search" className="form-group-icon-attach h-4" />
                                            </label>
                                            <input
                                                value={search}
                                                onChange={(e) => setSearch(e.target.value)}
                                                placeholder="Search pay groups"
                                                className="w-full border h-full form-input-icon focus:ring-transparent"
                                                style={{paddingLeft: "0",  outline: "none"}}
                                            />
                                        </div>
                                        <div className="flex items-center justify-end pt-4">
                                            <button onClick={() => setSelected(unassignedPayGroups)} className="text-ep-primary-600 mr-3">Select all</button>
                                            <button onClick={() => setSelected([])} className="text-ep-primary-600">Deselect all</button>
                                        </div>
                                    </div>

                                    <div style={{maxHeight: '300px'}} className="overflow-y-scroll modal-list-wrap mt-5">
                                        {filteredItems?.map((item, index) => {
                                            const isPreviouslyAssigned = allUniqueIDs?.includes(item.id)
                                            const isSelected = selected?.includes(item?.id)
                                            return <div onClick={() => isPreviouslyAssigned ? null : toggleSelection(item.id)} key={index} className={`flex items-start justify-between border rounded-md p-3.5 mb-5 cursor-pointer ${isPreviouslyAssigned && "cursor-not-allowed bg-[#f9fafb]"} ${isSelected && "border-ep-primary-600"}`}>
                                                        <div>
                                                            <p className="capitalize mb-1 font-medium tracking-wide text-ep-primary-600 flex items-center">
                                                                {item.name.toLowerCase()}
                                                                {isPreviouslyAssigned &&
                                                                    <span className="text-[8px] rounded-lg bg-ep-primary-500 flex items-center text-white px-2 py-1 ml-2">
                                                                        Pay group added
                                                                    </span>
                                                                }
                                                            </p>
                                                            <span className="lt-gray py-1">{item?.employee_ids?.length} {item?.employee_ids?.length > 1 ? "Employees" : "Employee"}</span>
                                                        </div>
                                                        <div className="flex items-center justify-center w-5 h-5 rounded-full border">
                                                            {isSelected && <Check />}
                                                        </div>
                                                </div>
                                        })}
                                    </div>
                                </div>

                        <div className="w-full flex items-center mt-12">
                            <ButtonLoader loading={updateLoading} disabled={selected?.length < 1} onClick={() => {
                                assignPayGroupFn().then(() => setTimeout(() => {
                                    toggleModal();
                                    setSelected([]);
                                    dispatch(getPayGroups());
                                    onMount(listParams);
                                }, 1500))
                            }} className="btn btn-md btn-ep-primary mr-4 lg:mr-6">
                                {updateLoading ? "Updating" : selected?.length > 1 ? "Add Pay Groups" : "Add Pay Group"}
                            </ButtonLoader>
                            <button onClick={clearAndClose} type='button' className="btn btn-md btn-transparent-primary">Close</button>
                        </div>
                        </>
                        }
                    </div>}
                </FormDrawer>
            </Maybe>

			<div>
                    <div className="flex items-center justify-end pb-5">
                        {!isViewing &&
							<button
								disabled={batch?.length > 1}
								onClick={toggleModal}
								className="flex items-center btn btn-md btn-transparent-primary font-medium">
								<AddIcon className='mr-3' />  Add Pay Group
							</button>
						}
                    </div>
                    {batch?.length > 1 && <div className="pb-8">
                        <BulkActionHandler
							deleteText="Remove Pay Groups"
							count={batch?.length}
							onCancel={() => {
								setBatch([]);
								setSelected([]);
                            }}
							onDelete={handleBulkDelete}
						/>
                    </div>}
                    <Table>
                            <Table.Head>
                                <th>
                                    <div className="flex items-center">
										{!isViewing &&
											<input
												onChange={toggleEntireList}
												type="checkbox"
												className="w-5 h-5 form-checkbox float-left"
												checked={batch?.length > 0 && batch?.length === allUniqueIDs?.length}
											/>
										}
                                        <p className={`mb-0 ${!isViewing && 'ml-4'}`}>Name of Pay group</p>
                                    </div>
                                </th>
                                <th>No. of Employees</th>
                                <th>Action</th>
                            </Table.Head>
                            <Table.Body>

                            <TableContent
                                loading={payGroupsLoading}
                                loadingText="Loading list"
                                data={payGroupsData?.data}
                                total={payGroupsData?.data?.length}
                                colspan={8}
                            />

                                {payGroupsLoading === false && payGroupsData?.data?.map((item, index) => {
                                    return <tr key={index}>
                                            <td>
                                                <div className="flex items-center">
                                                    {!isViewing &&
                                                        <input
                                                            value={item?.id} onChange={() => toggleSingleItem(item?.id)}
                                                            checked={batch?.includes(item?.id)}
                                                            type="checkbox" className="w-5 h-5 mr-4 form-checkbox float-left"
                                                        />
                                                    }
                                                    <p className="mb-0 capitalize">
														{item.name.toLowerCase()}
                                                    </p>
                                                </div>
                                            </td>
                                                <td>
                                                <p className="mb-0 lt-gray">
													{item?.employee_ids?.length}
                                                </p>
                                            </td>
                                            <td>
                                                <button
													disabled={isViewing}
													onClick={() => handleSingleDelete(item.id)}
													className={`${isViewing ? "cursor-not-allowed text-[#e5e7eb] text-opacitys-20" : "text-ep-danger"}`}>
														Remove Group
												</button>
                                            </td>
                                        </tr>
                                        }
                                    )}
                            </Table.Body>
                        </Table>

                        <Maybe condition={payGroupsLoading === false && payGroupsData?.data?.length > 0}>
                            <div className="mt-6">
                                <Pagination data={payGroupsData?.pageInfo} />
                            </div>
                        </Maybe>

                </div>
		</div>
	)
}

export default PaygroupsListTable